import { useEffect, useRef, useState } from "react"

export function Marquee({ children }: { children: string }) {
	const container = useRef<HTMLSpanElement>(null)
	const content = useRef<HTMLSpanElement>(null)
	const [overflow, setOverflow] = useState(0)

	useEffect(() => {
		const viewport = container.current
		const text = content.current
		if (!viewport || !text) return

		const observer = new ResizeObserver(() => {
			setOverflow(Math.max(0, text.scrollWidth - viewport.clientWidth))
		})
		observer.observe(viewport)
		observer.observe(text)
		return () => observer.disconnect()
	}, [children])

	return (
		<span ref={container} className="marquee" data-overflow={overflow > 1}>
			<span
				ref={content}
				className="marquee-content"
				style={{ animationDuration: `${Math.max(5, overflow / 35 + 3)}s` }}
			>
				{children}
			</span>
		</span>
	)
}
